import React from 'react'
import { withStyles } from '@material-ui/core/styles';
import Badge from '@material-ui/core/Badge';
import IconButton from '@material-ui/core/IconButton';
import MailIcon from '@material-ui/icons/Mail';
import { Link } from 'react-router-dom'
import * as routes from '../../constants/routes'


//props needed
// counter=counter number
// color = string (color) or undefined
//link = onClick link MY_MEEAGING_CENTER


const styles = theme => ({
    margin: {
      margin: theme.spacing.unit * 2,
    },
    padding: {
      padding: `0 ${theme.spacing.unit * 2}px`,
    },
  })
  
const MailCounter = (props) => {
    const { classes, counter, color } = props;
 
    const renderMailIcon = (
      <IconButton aria-label="inboxCounter" className={classes.margin}  >
              <Badge 
                  className={classes.margin}
                  aria-label="inboxCounter"
                  badgeContent={counter} 
                  color={counter!==0 
                          ? 'secondary'
                          : 'primary'}
              >
              <MailIcon style={{color: color || ''}}/>
              </Badge>
          </IconButton>
    )


    return (
         <div>
          {props.link
            ? <Link 
              className='navLink'
              to={routes[props.link]}
              children={renderMailIcon}
            />
            : renderMailIcon}
      
      </div>
    )
}


export default withStyles(styles)(MailCounter)


// WEBPACK FOOTER //
// ./src/Container/Counter/MailCounter.js